<template>
	<div>
		<van-nav-bar class="userNavBar" @click-left="onClickLeft" title="个人信息" left-arrow>
			<template #left>
				<van-icon name="../../../static/images/mobile/back.png" size="18" />
			</template>
		</van-nav-bar>
		<div class="information" style="display: flex; align-items: center">
			<div class="personal-information" style="width: 0.08rem; height: 0.346667rem; background: #dc0021; opacity: 1; border-radius: 0.053333rem"></div>
			基本信息
		</div>
		<van-cell  value="头像">
			<!-- 使用 title 插槽来自定义标题 -->
			<template #right-icon>
				<van-uploader :after-read="beforeRead">
					<van-image  round width="30" height="30" :src="picture" />
				</van-uploader>
			</template>
		</van-cell>
		<!-- <van-uploader :after-read="afterRead" /> -->
		<!-- 开启摄像头 -->
		<!-- <input type="file" accept="image/*" mutiple="mutiple" capture="camera" />  -->
		<van-cell @click="goMobilePersonalNickname" title="昵称" is-link :value="nickName" />
		<van-field
			class="personalMessagePlaceholder"
			readonly
			clickable
			name="sexpicker"
			:value="sex"
			label="性别"
			input-align="right"
		/>
		<!-- <van-popup v-model="sexShowPicker" position="bottom">
			<van-picker show-toolbar :columns="sexcolumns" @confirm="onSexConfirm" @cancel="sexShowPicker = false" />
		</van-popup> -->
		<!-- <div class="information" style="display: flex; align-items: center">
			<div class="personal-information" style="width: 0.08rem; height: 0.346667rem; background: #dc0021; opacity: 1; border-radius: 0.053333rem"></div>
			监管信息
		</div> -->
		<van-field class="studenType" input-align="right" readonly clickable name="picker" :value="userType" is-link label="学员类型" @click="showPicker = true" />
		<van-popup v-model="showPicker" position="bottom">
			<van-picker show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />
		</van-popup>
		<van-tabbar v-model="active">
			<van-tabbar-item to="/mobileHome">
				<span>首页</span>
				<template #icon="props">
					<img :src="props.active ? index.active : index.inactive" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item to="/mobileStudy">
				<span>班级</span>
				<template #icon="props">
					<img :src="props.active ? classes.active : classes.inactive" />
				</template>
			</van-tabbar-item>
			<van-tabbar-item to="/mobileMy">
				<span>我的</span>
				<template #icon="props">
					<img :src="props.active ? my.active : my.inactive" />
				</template>
			</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
import { Toast } from "vant";
export default {
	data() {
		return {
			name: "",
			picture: "",
			sex: "",
			sexcolumns: ["男", "女"],
			nickName: "",
			showPicker: false,
			sexShowPicker: false,
			value: "",
			userType: "",
			userTypes: "",
			active: 2,
			columns: ["贫困家庭劳动者", "毕业年度高校毕业生", "城乡未继续升学的应届初高中毕业生", "农村转移就业劳动者", "城镇登记失业人员", "企业员工", "其他"],
			index: {
				active: "../../../static/images/mobile/onIndex.png",
				inactive: "../../../static/images/mobile/index.png",
			},
			classes: {
				active: "../../../static/images/mobile/onClass.png",
				inactive: "../../../static/images/mobile/class.png",
			},
			my: {
				active: "../../../static/images/mobile/onMy.png",
				inactive: "../../../static/images/mobile/my.png",
			}, //table栏
		};
	},
	methods: {
		// 返回布尔值
		beforeRead(file) {
			let content = file.file;
			let formData = new FormData();
			formData.append("file", content);
			formData.append("uploadType", "image");
			formData.append("size", file.file.size);
			this.$api.formpost("/FileUpload/upload", formData, (res) => {
				if ((res.status = "success")) {
					this.picture = res.showAddress;
					this.onpicture();
				}
			});
		},
		onpicture() {
			let params = {};
			params.picture = this.picture;
			this.$axiosPackag.getMessageByAxios("post", "/user/personsetdo", null, params, null, (resD) => {
				Toast("修改成功");
			});
		},
		onConfirm(userTypes) {
			let params = {};
			this.userTypes = userTypes;
			params.userType = this.userTypes;
			this.$axiosPackag.getMessageByAxios("post", "/user/personsetdo", null, params, null, (resD) => {
				Toast("修改成功");
				this.showPicker = false;
				this.getUserInfor();
			});
		},
		onSexConfirm() {
			let params = {};
			params.sex = this.sex;
			this.$axiosPackag.getMessageByAxios("post", "/user/personsetdo", null, params, null, (resD) => {
				Toast("修改成功");
				this.sexShowPicker = false;
			});
		},
		/**
		 * 获取个人信息
		 */
		judgeLogin() {
			if (localStorage.getItem("loginUrl")) {
				this.getUserInfor();
			} else {
				Toast("请先登录");
				this.$router.push({ path: "/mobileLogin" });
			}
		},
		getUserInfor() {
			this.$api.get("/user/getUserDetail", null, (res) => {
				if (status == 0) {
					this.name = res.data.realName;
					this.picture = res.data.picture;
					this.sex = res.data.sex;
					this.nickName = res.data.nickName;
					this.userType = res.data.userType;
				}
			});
		},
		onClickLeft() {
			this.$router.go(-1);
		},
		goMobilePersonalNickname() {
			this.$router.push({ path: "/mobilePersonalNickname" });
		},
		personalSet() {
			let params = {};
			params.realName = this.form.name;
			params.picture = this.form.picture;
			params.sex = this.form.sex;
			if (this.$util.isBlackStr(this.form.name)) {
				Toast("请输入姓名");
				return false;
			}
			if (this.$util.isBlackStr(this.form.sex)) {
				Toast("请输入性别");
				return false;
			}
			if (this.$util.isBlackStr(this.form.picture)) {
				Toast("请上传头像");
				return false;
			}
			this.$axiosPackag.getMessageByAxios("post", "/user/personsetdo", null, params, null, (resD) => {
				Toast("修改成功");
			});
		},
	},
	mounted() {
		this.judgeLogin();
	},
	beforeCreate() {
		document.querySelector("body").setAttribute("style", "background:#eee");
	}, //
	beforeDestroy() {
		document.querySelector("body").removeAttribute("style");
	},
};
</script>
<style >
.userNavBar .van-nav-bar__title {
    font-weight: 600;
}
</style>
<style scoped>
.body {
	background-color: #f2f2f2;
}
.information {
	font-weight: bold;
	font-size: 0.373333rem;
	margin-top: 0.426667rem;
    margin-bottom: .32rem;
}
.personal-information {
	margin-left: 0.426667rem;
	margin-right: 0.213333rem;
}
.van-cell__value--alone {
	color: #555555;
}
.van-cell__title {
	color: #555555;
}
.van-cell {
	height: 1.6rem;
	padding: 0.533333rem 0.533333rem;
    width: 9.146667rem;
	margin: 0 auto;
    border-radius: 0.106667rem 0.106667rem 0 0;
}
.studenType{
    border-radius:0 0 0.106667rem 0.106667rem;
}
</style>




// WEBPACK FOOTER //
// MobilePersonalMessage.vue?167b7c2a